<template>
  <div class="footerNav">
    <div class="container">
      <footer>
        <div class="left">
          <dl>
            <dt>关于我们</dt>
            <dd><router-link to="/home/profile">公司简介</router-link></dd>
            <dd><router-link to="/home/league">招商加盟</router-link></dd>
            <dd><router-link to="/home/staff">成为员工</router-link></dd>
          </dl>
          <dl>
            <dt>帮助中心</dt>
            <dd><router-link to="/home/issue">常见问题</router-link></dd>
          </dl>
        </div>
        <div class="right">
          <div class="info">
            <img src="../assets/images/home/record(1).png" alt="">
            <div>
              <span>广东省通讯管理局</span>
             <a target="_blank" href="https://beian.miit.gov.cn/">  <span>粤ICP备17101953号</span></a> 
            </div>
          </div>
          <div class="info">
            <!-- <img src="../assets/images/home/record(2).png" alt="">
            <div>
              <span >深圳市计算机网络公共安全协会</span>
              <span>备11022033300555</span>
              <span >粤公网安备 11022033300555</span>
            </div> -->
          </div>
          <p class="copy">copyright@深圳市一线快递服务有限公司 版权所有 违者必究</p>
        </div>
      </footer>
    </div>
  </div>
</template>
 <script>
export default {
  created() {
    var hccid=83204596;
    var nt=document.createElement("script");
    // nt.async=true;
    nt.src="https://www.mylivechat.com/chatinline.aspx?hccid="+hccid;
    var ct=document.getElementsByTagName("script")[0];
    ct.parentNode.insertBefore(nt,ct);
  },
}
</script>

<style scoped lang="less" type="text/less">
.footerNav{
  padding:32px 0;
  background: #fbfbfb;
  footer{
    display: flex;
    .left{
      display: flex;
      margin-left: 122px;
      margin-right: 260px;
      dl{
        margin-right: 80px;
        dt{
          font-size: 20px;
          font-weight: 700;
        }
        dd{
          margin-top:30px;
          font-size: 16px;
        }
      }
    }
    .right{
      font-size: 14px;
      .info{
        overflow: hidden;
        line-height: 30px;
        margin-bottom: 16px;
        img{
          float: left;
          margin-right:6px;
        }
        div{
          float: left;
          width: 382px;
          span{
            margin-right: 21px;
          }
        }
      }
      .copy{
        margin-left: 30px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/FooterNav.vue